// extracted by mini-css-extract-plugin
export default {"root":"_1VR-r","dd":"_2hvJS","status-indicators":"_1RSk3","statusIndicators":"_1RSk3"};